var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2313_57307)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2313_57307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.918565 27.6023L14.1986 4.86719C15.8854 5.86031 24.3917 10.5678 25.7654 11.4631L12.4854 34.1995C11.0331 36.1183 -0.921435 30.5141 0.918565 27.6011V27.6023Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0733 27.6019L25.7933 4.86812C23.9367 1.77843 19.9383 0.655616 16.6541 2.48046C13.3699 4.3053 12.3699 8.23624 14.2264 11.4639L27.5064 34.2005C29.363 37.2887 33.3616 38.4114 36.6458 36.5867C39.7864 34.7617 40.9299 30.6914 39.0733 27.6045V27.6019Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66625 37.4651C10.3479 37.4651 13.3325 34.5547 13.3325 30.9645C13.3325 27.3743 10.3479 24.4639 6.66625 24.4639C2.98458 24.4639 0 27.3743 0 30.9645C0 34.5547 2.98458 37.4651 6.66625 37.4651Z",
    fill: "#34A853"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2313_57307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2313_57307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.9375,
    fill: "white",
    transform: "translate(0 1.60156)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b2d44405909221b42f513ffff5010ee4.svg";
export { ForwardRef as ReactComponent };